import { Link, FC, useMemo } from 'external/react'

import Icon from 'external/fortawesome'
import usePublic from 'context/public-context/hook'
import { clsx } from 'external/clsx'
import usePayment from 'context/payment-context/hook'

type AddCourseProps = {
	idSelectCourse: number
	typeSubject: 'basic' | 'elective'
}

const AddCourse: FC<AddCourseProps> = (props) => {

    const {typeSubject, idSelectCourse} = props
	const {navigation, offerData} = usePublic()
	const {cart} = usePayment()

	// Add Logic to switch to english if no spanish course is available
	const languageId = useMemo(() => {
		if (typeSubject === 'basic') {
			const selectedSubjects = cart.properties.basic.filter(i => i ).map(c => c.substring(0, 2))
			if (selectedSubjects.length < 4) return 'es'
			if (selectedSubjects.indexOf('C1') >= 0) return 'en'
			return 'es'
		} else {
			return 'es'
		}
	}, [typeSubject, cart, offerData])

    const to = useMemo(() =>
        navigation.offer.active && navigation.offerSubjects.linkWithQuery({languageId}, false, {idSelectCourse, typeSubject})
	, [navigation])


	return (
		<Link to={to} className='text-decoration-none hfc' >
			<div className={clsx('container__selectedCourse', 'offer')}>
				<Icon
					name='faCirclePlus'
					color='#CCCCCC'
					className='plus-rounded-default fa-3x'
				/>
				<Icon
					name='faCirclePlus'
					color='#1797D0'
					className='plus-rounded-active fa-3x'
				/>
				<span>Agrega tu curso</span>
			</div>
		</Link>
    )
}

export {AddCourse as default}